export const TABLE_DATA = {
  heading: "Supported Migrations & Hybrid Flexibility ",
  tableHeading: [
    "Source Platform ",
    "Destination with Zadara ",
    "Migration Tools & Features",
  ],
  tableData: [
    {
      Source: (
        <>
          VMware
          <br />
          vSphere
        </>
      ),
      Destination: (
        <>
          Zadara zCompute +
          <br />
          zStorage
        </>
      ),
      Migration_tools: [
        {
          label: "V2Z Migration Tool",
          text: "Facilitates direct migration from VMware environments to Zadara zCompute.  ",
        },
        {
          label: "AWS EC2 Compatible APIs",
          text: "Simplifies integration and management. ",
        },
      ],
    },
    {
      Source: " Nutanix AHV",
      Destination: "Zadara Edge Cloud",
      Migration_tools: [
        {
          label: "Batch-Oriented Migration Tools",
          text: "Support migrations from platforms like Nutanix AHV to Zadara.",
        },
        {
          label: "Multi-Cloud Support",
          text: "Enables integration with AWS, Azure, and other public clouds.",
        },
      ],
    },
    {
      Source: " Microsoft Hyper-V",
      Destination: "Zadara zCompute",
      Migration_tools: [
        {
          label: "V2Z Migration Tool",
          text: "Supports direct migration from Hyper-V environments to Zadara zCompute.",
        },
        {
          label: "Remote Cloning",
          text: "Allows instant availability of data volumes across different environments.",
        },
      ],
    },
    {
      Source: " On-Premises Datacenter",
      Destination: "Zadara Hosted Infrastructure",
      Migration_tools: [
        {
          label: "Remote Mirroring",
          text: "Ensures data availability with automatic replication across data centers.",
        },
      ],
    },
  ],
};
